export default "__VITE_PUBLIC_ASSET__9925b366__"